let t = () => `
    <div class="toolbar-block universal-search-tool-region"></div>
    <div class="toolbar-block geoselection-tool-region"></div>
    <div class="toolbar-block basemap-region basemap-tool"></div>
    <div class="toolbar-block layerpicker-tool-region"></div>
    <div class="toolbar-block bookmark-picker"></div>
    <div class="toolbar-block measure-tool-region"></div>
    <div class="toolbar-block feature-selection-tools"></div>
    <div class="toolbar-block annotation-tool-region"></div>
`;

export = t;